import { render } from "./RecentLabReports.vue?vue&type=template&id=f87692d0&scoped=true&ts=true"
import script from "./RecentLabReports.vue?vue&type=script&lang=ts"
export * from "./RecentLabReports.vue?vue&type=script&lang=ts"

import "./RecentLabReports.vue?vue&type=style&index=0&id=f87692d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87692d0"]])

export default __exports__